import React, { useEffect, useState } from "react";
import defaultImage from "../Images/404.png";
const DefaultPage = () => {


    return (
        <>
            <div
                style={{
                    display: "flex",
                    height: "100vh",
                    justifyContent: "center",
                }}
            >
                <div
                    style={{
                        height: "48vh",
                        width: "30vw",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-evenly",
                        alignItems: "center",
                        backgroundColor: "white",
                        borderRadius: "10px",
                        marginTop: '6em'
                    }}
                >
                    <img
                        src={defaultImage}
                        style={{
                            objectFit: "contain",
                            height: "60vh",
                            width: "60vh",
                        }}
                    />
                    <span
                        style={{ fontWeight: "700", color: "black", fontSize: "1.8em" }}
                    >
                        Oops! Page not found
                    </span>
                    <span
                        style={{ fontWeight: "500", color: "#555557", fontSize: "1em" }}
                    >
                        We can’t seem to find the page you’re looking for.            </span>

                </div>
            </div>
        </>
    );
};

export default DefaultPage;
